import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import { byId } from 'store/utils/sortFunctions';
import OutcomeIndicator from 'models/ImpactPlan/OutcomeIndicator';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.OUTCOME_INDICATORS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results
              .reduce(
                (outcomeIndicatorsById, outcomeIndicator) =>
                  outcomeIndicatorsById.set(
                    String(outcomeIndicator.id),
                    new OutcomeIndicator(outcomeIndicator)
                  ),
                state.get('data').get('byId')
              )
              .sort(byId),
          },
        })
      );
    case types.OUTCOME_INDICATOR_FETCH_SUCCEEDED:
    case types.OUTCOME_INDICATOR_CREATE_SUCCEEDED:
    case types.OUTCOME_INDICATOR_UPDATE_SUCCEEDED: {
      return (() =>
        state.merge(
          reduxHelper.applyRequestInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(String(action.payload.id), new OutcomeIndicator(action.payload)),
            },
          })
        ))();
    }
    case types.OUTCOME_INDICATOR_FETCH:
    case types.OUTCOME_INDICATOR_CREATE:
    case types.OUTCOME_INDICATOR_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.OUTCOME_INDICATOR_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(String(action.payload.id)),
          },
        })
      );
    case types.OUTCOME_INDICATOR_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.OUTCOME_INDICATOR_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.OUTCOME_INDICATOR_FETCH_FAILED:
    case types.OUTCOME_INDICATORS_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
